import React from 'react';
import PropTypes from 'prop-types';
import TimeInputRow from './TimeInputRow';
import NumberInputRow from './NumberInputRow';


class NumberOrTimeInputRow extends React.Component {
  render() {
    const { isTimeFormat, onClearRow, ...otherProps } = this.props;

    return (
      isTimeFormat ? <TimeInputRow {...otherProps} onClearRow={onClearRow} /> : <NumberInputRow {...otherProps} onClearRow={onClearRow} />
    );
  }
}

NumberOrTimeInputRow.propTypes = {
  isTimeFormat: PropTypes.bool.isRequired,
  onClearRow: PropTypes.func
};

NumberOrTimeInputRow.defaultProps = {
  isTimeFormat: false,
};

export default NumberOrTimeInputRow;
